import { warRoomClient } from './warRoomClient'
import type { PreflightItem } from '../types/session.types'

export const preflightService = {
  /**
   * List all preflight items for a session.
   */
  list: (sessionId: string): Promise<{ data: PreflightItem[] }> =>
    warRoomClient.get(`sessions/${sessionId}/preflight`).json(),

  /**
   * Check a preflight item.
   */
  check: (
    sessionId: string,
    itemId: string,
    payload: { status: 'passed' | 'failed' | 'na'; result_note?: string; evidence_url?: string }
  ): Promise<{ data: PreflightItem }> =>
    warRoomClient.patch(`sessions/${sessionId}/preflight/${itemId}`, { json: payload }).json(),

  /**
   * Waive a preflight item.
   */
  waive: (
    sessionId: string,
    itemId: string,
    reason: string
  ): Promise<{ data: PreflightItem }> =>
    warRoomClient.post(`sessions/${sessionId}/preflight/${itemId}/waive`, {
      json: { reason }
    }).json(),
}
